export enum BorrowerCompanyVariable {
  CompanyName = 'companyName1',
  CompanyMappingId = 'companyMappingId1',
  SecondCompanyName = 'companyName2',
  SecondCompanyMappingId = 'companyMappingId2',
  ThirdCompanyName = 'companyName3',
  ThirdCompanyMappingId = 'companyMappingId3',
}
